import { FC } from 'react';

import { Spinner, Stack } from '@servicetitan/design-system';

export const PageSpinner: FC = () => (
    <Stack className="w-100" alignItems="center" justifyContent="center">
        <Spinner size="large" />
    </Stack>
);
PageSpinner.displayName = 'PageSpinner';
